export default {
  REDEEMED: 'redeemed',
  REDEMPTION_FAILURE: 'redemptionFailure',
  TO_BE_REDEEMED: 'toBeRedeemed',
};
